/* eslint-disable react-refresh/only-export-components --
 * Context module: Provider + hooks are intentionally co-located.
 */
import React, { createContext, useContext } from 'react';

export interface MultiselectFieldContextValue {
  qid: string;
  values: string[];
  options: { value: string; label: string }[];
  toggle: (value: string) => void;
  setValues: (next: string[]) => void;
  /** Compound option checkboxes inherit layout `disabled-when` / stacked gates */
  disabled?: boolean;
}

const MultiselectFieldContext =
  createContext<MultiselectFieldContextValue | null>(null);

export function MultiselectFieldProvider({
  value,
  children,
}: {
  value: MultiselectFieldContextValue;
  children: React.ReactNode;
}) {
  return (
    <MultiselectFieldContext.Provider value={value}>
      {children}
    </MultiselectFieldContext.Provider>
  );
}

export function useOptionalMultiselectField(): MultiselectFieldContextValue | null {
  return useContext(MultiselectFieldContext);
}

/** @throws when used outside `OASISMultiselect` compound mode */
export function useMultiselectField(): MultiselectFieldContextValue {
  const ctx = useOptionalMultiselectField();
  if (!ctx) {
    throw new Error(
      'useMultiselectField must be used inside OASISMultiselect (compound layout)'
    );
  }
  return ctx;
}
